import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { NormalizedUIField } from '../../../store/config.models';

@Component({
    selector: 'app-text-element',
    templateUrl: './text-element.component.html',
    styleUrls: ['./text-element.component.scss'],
})
export class TextElementComponent {
    @Input() field: NormalizedUIField;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    /**
     * Handles text click actions by dispatching any configured events
     */
    onTextAction(event: Event): void {
        if (this.field.events?.onClick) {
            this.field.events.onClick(event).forEach((action) => this.store.dispatch(action));
        }
    }
}
